/**
 * DreamPay Private API [DEPRECATED]
 * ⚠️ **DEPRECATED** - This API version is deprecated and will be removed on 2026-05-31. Please migrate to V2.  Private API v1 - Legacy endpoints for DreamPay payment processing platform.
 *
 * The version of the OpenAPI document: v1
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RedeReportRow {
  id?: number;
  date?: string;
  time?: string;
  status?: string;
  originalValue?: number;
  updatedValue?: number | null;
  modality?: string;
  type?: string;
  installments?: number;
  cardBrand?: string;
  mdrRate?: number | null;
  mdrValue?: number;
  autoReceivingRate?: number | null;
  autoReceivingValue?: number | null;
  totalFeesRate?: number | null;
  totalFeesValue?: number | null;
  netValue?: number | null;
  nsu?: string;
  receivingTerm?: string;
  batchNumber?: string;
  authorizationCode?: string;
  establishmentNumber?: string;
  establishmentName?: string;
  cnpj?: string;
  cardNumber?: string;
  digitalWalletId?: string;
  paymentMethod?: string;
  terminalType?: string;
  terminalCode?: string;
  tid?: string;
  orderNumber?: string;
  boardingFee?: number;
  canceledByEstablishment?: boolean;
  cancellationDate?: string | null;
  canceledValue?: number | null;
  inChargebackDispute?: boolean;
  chargebackDisputeDate?: string | null;
  chargebackResolution?: string;
  chargebackResolutionDate?: string | null;
  cardNationality?: string;
  foreignCurrencyDcc?: boolean;
  prepaidCard?: boolean;
  redeTransactionId?: string;
  rowIndex?: number;
}
